import happyEmoji from "../../assets/happyEmoji.png";
import sadEmoji from "../../assets/sadEmoji.png";

interface ClimateGaugeProps {
  indice: number;
}

export const ClimateGauge = (props: ClimateGaugeProps) => {
  return (
    <div className="flex justify-center gap-2 items-center ">
      <div className="w-[90%] h-5 bg-white shadow rounded-full m-auto my-2 relative flex items-center ">
        <div className="flex w-full h-full absolute">
          <div className="bg-gradient-to-r from-red-400 via-yellow-400 to-green-400 w-full h-full rounded-full shadow-2xl" />
        </div>

        <img
          src={props.indice >= 50 ? happyEmoji : sadEmoji}
          className="w-11 h-11 absolute"
          style={{
            marginLeft: `${props.indice}%`,
            transform: "translateX(-50%)",
          }}
          alt=""
        />
      </div>
    </div>
  );
};
